import { Button, Col, Form, Row, OverlayTrigger, Tooltip} from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useEffect, useState } from "react"
import Select from "react-select"
import { useAuth } from "../auth/useAuth"
import { getBreedOptions } from '../../constants/breedOptions'
import { getSexOptions } from '../../constants/sexOptions'
import { getEntryTypeOptions } from "../../constants/entryTypeOptions"
import { getBooleanOptions } from "../../constants/booleanOptions"
import { getCategoryOptions } from "../../constants/categoryOptions"

export default function AnimalForm({state, handleInputChange, submit, isAddingOrEditing, isRegistering, lotOptions = []}) {
	const { t } = useTranslation()

	const lots = lotOptions?.map(lot => ({
		value: lot._id,
		label: lot.identifier
	}));

	const breedOptions = getBreedOptions(t)
	const sexOptions = getSexOptions(t)
	const entryTypeOptions = getEntryTypeOptions(t)
	const booleanOptions = getBooleanOptions(t)
	const categoryOptions = getCategoryOptions(t)

	const productiveStatusOptions = state.category === 'vaca' ? [
		{ value: 'criando', label: t('admin.animal.reproductive_status_criando') },
		{ value: 'seca', label: t('admin.animal.reproductive_status_seca') },
		{ value: 'desvieje', label: t('admin.animal.reproductive_status_desvieje') },
	] : state.category === 'semental' ? [
		{ value: 'en_reposo', label: t('admin.animal.productive_status_en_reposo') },
		{ value: 'en_cubricion', label: t('admin.animal.productive_status_en_cubricion') },
	] : []

	return (
		<Form onSubmit={submit} className="px-4 formulario">
			<Row className="my-2">
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.animal.identifier')}</Form.Label>
						<Form.Control
							type="text"
							name="identifier"
							value={state.identifier || ''}
							onChange={handleInputChange}
						/>
					</Form.Group>
				</Col>
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.animal.crotal')}</Form.Label>
						<Form.Control
							type="text"
							name="crotal"
							value={state.crotal || ''}
							onChange={handleInputChange}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row className="my-2">
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.animal.lot')}</Form.Label>
						<Select
							options={lots}
							value={state.lot ? lots?.find(option => option.value === state.lot._id) : null}
							onChange={option => handleInputChange({ target: { name: 'lot', value: option.value } })}
						/>
					</Form.Group>
				</Col>
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.animal.entryType')}</Form.Label>
						<Select
							options={entryTypeOptions}
							value={entryTypeOptions.find(o => o.value === state.entryType)}
							onChange={option => handleInputChange({ target: { name: 'entryType', value: option.value } })}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row className="my-2">
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.animal.birthDate')}</Form.Label>
						<Form.Control
							type="date"
							name="birthDate"
							value={state.birthDate ? new Date(state.birthDate).toISOString().split('T')[0] : ''}
							onChange={handleInputChange}
							required
						/>
					</Form.Group>
				</Col>
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.animal.sex')}</Form.Label>
						<Select
							options={sexOptions}
							value={state.sex ? sexOptions.find(o => o.value === state.sex) : null}
							onChange={option => handleInputChange({ target: { name: 'sex', value: option.value } })}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row className="my-2">
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.animal.castrated')}</Form.Label>
						<Select
							options={booleanOptions}
							value={state.castrated ? booleanOptions.find(o => o.value === state.castrated) : null}
							onChange={option => handleInputChange({ target: { name: 'castrated', value: option.value } })}
						/>
					</Form.Group>
				</Col>
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.animal.breed')}</Form.Label>
						<Select
							options={breedOptions}
							value={breedOptions.find(o => o.value === state.breed)}
							onChange={option => handleInputChange({ target: { name: 'breed', value: option.value } })}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row className="my-2">
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.animal.category')}</Form.Label>
						<Select
							options={categoryOptions}
							value={categoryOptions.find(o => o.value === state.category)}
							onChange={option => handleInputChange({ target: { name: 'category', value: option.value } })}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row className="my-2">
				{state.category === 'semental' || state.category === 'vaca' ?
					<Col xs={12} md={6}>
						<Form.Group className="mb-3">
							<Form.Label>{t('admin.animal.productive_status')}</Form.Label>
							<Select
								options={productiveStatusOptions}
								value={productiveStatusOptions.find(o => o.value === state.productiveStatus)}
								onChange={option => handleInputChange({ target: { name: 'productiveStatus', value: option.value } })}
							/>
						</Form.Group>
					</Col>
				:
					<></>
				}
			</Row>
			<Row>
				<Col xs={12} lg={6} className="my-2 ms-auto">
					<Button variant='primary' type="submit" className="w-100 my-2">
					{isRegistering ?
						<>
							<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
						</>
					:
						isAddingOrEditing === 'editing' ?
							<>{t('admin.animal.edit')}</>
						:
							<>{t('admin.animal.register')}</>
					}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}
